import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValueList } from '../../../../Fct/generics';
export var SafeBatchTransferFrom = createPlugin({
    protocol: 'ERC1155',
    type: 'ACTION',
    method: 'safeBatchTransferFrom',
    supportedContracts: undefined,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'erc1155' }),
                methodParams: {
                    from: new FctAddress({}),
                    to: new FctAddress({}),
                    ids: new FctValueList({}),
                    amounts: new FctValueList({}),
                    data: new FctBytes({ readonly: true }),
                },
            },
            output: {},
        });
    },
    initParams: {
        methodParams: { data: '0x' },
    },
    requiredApprovals: function (params, _chainId, _walletAddress, vaultAddress) {
        var to = params.to, methodParams = params.methodParams;
        var from = methodParams.from.value;
        if (!vaultAddress || (typeof from === 'string' && vaultAddress.toLowerCase() === from.toLowerCase()))
            return [];
        return [
            {
                to: to.value,
                from: from,
                params: { operator: to.value, approved: 'true' },
                method: 'setApprovalForAll',
                protocol: 'ERC1155',
            },
        ];
    },
});
